import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-unknown-payment',
  templateUrl: './unknown-payment.component.html',
  styleUrls: ['./unknown-payment.component.scss']
})
export class UnknownPaymentComponent implements AfterViewInit {
  @ViewChild("table", { static: false }) table: TableComponent;

  public company_uuid;

  constructor(private http: HttpService) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/unknow-payment/get", data: {}},
        disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Bank Name', type: 'string', key: 'bank_title'}, 
            {label: 'Debit', type: 'price', key: 'debit'}, 
            {label: 'Received On', type: 'date', key: 'timestamp'}, 
            {label: 'Claim', type: 'link', key: 'id', 'link': '/lo/' + this.company_uuid + '/unknown-payment/claim/' , hide: true},
          ]}
        this.table.init(setting);
  }

}
